import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { MatrixTooltipComponent } from './matrix-tooltip.component';

@NgModule({
    imports: [CommonModule, TranslateModule],
    declarations: [MatrixTooltipComponent],
    exports: [MatrixTooltipComponent]
})
export class MatrixTooltipModule {}
